import * as React from "react";
import {
  List, Datagrid, NumberField, Show, SimpleShowLayout,
  useRecordContext,
} from "react-admin";
import { Box, Typography, Paper } from "@mui/material";
import { UserRefField, TechInfo } from "../../components/ui";

// Sessions IA (ChatGpt) — snapshot in-memory exposé par GET /chat/sessions.
// Volatile : perdu au redémarrage de l'instance backend.
const Messages = () => {
  const r = useRecordContext();
  const msgs = Array.isArray(r?.messages) ? r.messages : [];
  if (!msgs.length)
    return <Typography sx={{ p: 1 }} color="text.secondary">Aucun message</Typography>;
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1 }}>
      {msgs.map((m, i) => (
        <Paper
          key={i}
          variant="outlined"
          sx={{ p: 1.5, bgcolor: m.role === "user" ? "#eef4ff" : "#f7f7f7" }}
        >
          <Typography variant="caption" sx={{ fontWeight: 700, textTransform: "uppercase" }}>
            {m.role || "?"}
          </Typography>
          <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
            {m.content}
          </Typography>
        </Paper>
      ))}
    </Box>
  );
};

export default {
  list: () => (
    <List perPage={50} title="Sessions IA (en mémoire)" pagination={false}>
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <UserRefField source="userId" label="Utilisateur" />
        <NumberField locales="fr-FR" source="messageCount" label="Messages" />
      </Datagrid>
    </List>
  ),
  show: () => (
    <Show title="Session IA">
      <SimpleShowLayout>
        <UserRefField source="userId" label="Utilisateur" />
        <NumberField locales="fr-FR" source="messageCount" label="Nombre de messages" />
        <Messages />
        <TechInfo />
        </SimpleShowLayout>
    </Show>
  ),
};
